import React from 'react'
import { A } from './Styles.js'

export class Input extends React.Component {
  render() {
    const { value, handleChange, valid, format, unformat, style, ...passThruProps } = this.props

    if (this.props.type === `checkbox`) {
      return (
        <input
            checked={this.state.value === true ? true : false}
            data-value={this.state.value}
            onChange={e => this.handleChange(e.target.checked)}
            style={{
              boxSizing: `border-box`,
              border: (
                (!this.state.required && this.state.value && this.state.value.length > 0 && !this.state.valid && this.state.altered)
                || (this.state.required && !this.state.valid && this.state.altered))
                  ? `5px solid red`
                  : undefined,
              ...this.props.style,
            }}
            {...passThruProps}
        />
      )
    }

    return (
      <input
          value={this.format(this.state.value)}
          data-value={this.state.value}
          onChange={e => this.handleChange(e.target.value)}
          style={{
            boxSizing: `border-box`,
            border: (
              (!this.state.required && this.state.value && this.state.value.length > 0 && !this.state.valid && this.state.altered)
              || (this.state.required && !this.state.valid && this.state.altered))
                ? `5px solid red`
                : undefined,
            ...this.props.style,
          }}
          {...passThruProps}
      />
    )
  }

  constructor(props) {
    super(props)

    this.format = this.format.bind(this)

    this.state = {
      altered: false,
      valid: this.props.valid !== undefined ? this.props.valid : true,
      value: (this.props.format && this.props.unformat) ? this.props.format(this.props.value) : this.props.value,
      required: this.props.required !== undefined ? this.props.required : true
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        valid: nextProps.valid !== undefined ? nextProps.valid : this.state.valid,
        value: nextProps.value !== undefined ? nextProps.value : this.state.value,
      })
    }
  }

  handleChange(newValue) {
    this.setState({
      altered: true,
    })

    if (this.props.handleChange) {
      if (this.props.format && this.props.unformat) {
        this.props.handleChange(this.props.unformat(newValue))
        return
      }

      this.props.handleChange(newValue)
      return
    }

    this.setState({
      value: newValue,
    })
  }

  format(value) {
    if (this.props.format && this.props.unformat) {
      return this.props.format(value)
    }
    return value
  }
}

export class UsernameInput extends React.Component {
  render() {
    const {value, handleChange, valid, placeholder, style, ...passThruProps} = this.props

    return (
      <Input
          type="text"
          value={this.state.value}
          handleChange={username => this.validate(username)}
          valid={this.state.valid}
          placeholder={this.props.placeholder || `Username`}
          style={{...this.props.style}}
          {...passThruProps}
      />
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      valid: props.valid !== undefined ? props.valid : false,
      value: props.value !== undefined ? props.value : ``,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        valid: nextProps.valid !== undefined ? nextProps.valid : this.state.valid,
        value: nextProps.value !== undefined ? nextProps.value : this.state.value,
      })
    }
  }

  // componentWillUpdate(nextProps, nextState) {
  //   if (nextState !== this.state && this.props.handleChange) {
  //     this.props.handleChange(nextState.value, nextState.valid)
  //   }
  // }

  validate(username) { // for some things, like github, can have 2 letter usernames!
    const allowedCharactersRegex = /^[a-zA-Z0-9_]*$/
    const validUsernameRegex = /^[a-zA-Z]{1}[a-zA-Z0-9_]{2,24}$/

    if (username.length === 0) {
      this.setState({
        valid: false,
        value: ``,
      })
      this.props.handleChange && this.props.handleChange(``, false)
      return
    }

    if (!username.match(allowedCharactersRegex)) {
      return
    }

    if (!username.match(validUsernameRegex)) {
      this.setState({
        valid: false,
        value: username,
      })
      this.props.handleChange && this.props.handleChange(username, false)
      return
    }

    this.setState({
      valid: true,
      value: username,
    })
    this.props.handleChange && this.props.handleChange(username, true)
  }
}

export class EmailInput extends React.Component {
  render() {
    const {value, handleChange, valid, placeholder, style, ...passThruProps} = this.props

    return (
      <Input
          type="text"
          value={this.state.value}
          handleChange={email => this.validate(email)}
          valid={this.state.valid}
          placeholder={this.props.placeholder || `Email`}
          style={{...this.props.style}}
          {...passThruProps}
      />
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      valid: props.valid !== undefined ? props.valid : false,
      value: props.value !== undefined ? props.value : ``,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        valid: nextProps.valid !== undefined ? nextProps.valid : this.state.valid,
        value: nextProps.value !== undefined ? nextProps.value : this.state.value,
      })
    }
  }

  validate(email) {
    const allowedCharactersRegex = /^[a-zA-Z0-9._%+-@]*$/
    const validEmailRegex = /^[a-zA-Z0-9._%+-]{1,}@[a-z0-9.-]{1,}\.[a-z]{2,63}$/

    if (email.length === 0) {
      this.setState({
        valid: false,
        value: ``,
      })
      this.props.handleChange && this.props.handleChange(``, false)
      return
    }

    if (!email.match(allowedCharactersRegex)) {
      return
    }

    if (!email.match(validEmailRegex)) {
      this.setState({
        valid: false,
        value: email,
      })
      this.props.handleChange && this.props.handleChange(email, false)
      return
    }

    this.setState({
      valid: true,
      value: email,
    })
    this.props.handleChange && this.props.handleChange(email, true)
  }
}

export class PhoneInput extends React.Component {
  render() {
    const {value, handleChange, valid, placeholder, style, ...passThruProps} = this.props

    return (
      <Input
          type="text"
          value={this.state.value}
          handleChange={phone => this.validate(phone)}
          valid={this.state.valid}
          format={phone => this.format(phone)}
          unformat={phone => this.unformat(phone)}
          placeholder={this.props.placeholder || `Phone`}
          style={{...this.props.style}}
          {...passThruProps}
      />
    )
  }

  constructor(props) {
    super(props)

    this.state = {
      valid: props.valid !== undefined ? props.valid : false,
      value: props.value !== undefined ? props.value : ``,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        valid: nextProps.valid !== undefined ? nextProps.valid : this.state.valid,
        value: nextProps.value !== undefined ? nextProps.value : this.state.value,
      })
    }
  }

  // relic, saving in case need to return to this
  // componentWillUpdate(nextProps, nextState) {
  //   if (nextState !== this.state && this.props.handleChange) {
  //     this.props.handleChange(nextState.value, nextState.valid)
  //   }
  // }

  validate(phone) {
    const allowedCharactersRegex = /^[0-9]*$/
    const validPhoneRegex = /^[2-9]{1}[0-9.-]{9}$/

    if (phone.length === 0) {
      this.setState({
        valid: false,
        value: ``,
      })
      this.props.handleChange && this.props.handleChange(``, false)
      return
    }

    if (!phone.match(allowedCharactersRegex)) {
      return
    }

    if (!phone.match(validPhoneRegex)) {
      this.setState({
        valid: false,
        value: phone,
      })
      this.props.handleChange && this.props.handleChange(phone, false)
      return
    }

    this.setState({
      valid: true,
      value: phone,
    })
    this.props.handleChange && this.props.handleChange(phone, true)
  }

  format(phone) {
    const rawPhone = this.unformat(phone)

    switch (true) {
    case (rawPhone.length <= 3):
      return rawPhone
    case (rawPhone.length <= 7):
      return `${rawPhone.slice(0,3)} - ${rawPhone.slice(3)}`
    case (rawPhone.length <= 10):
      return `(${rawPhone.slice(0,3)}) ${rawPhone.slice(3,6)} - ${rawPhone.slice(6)}`
    default:
      return rawPhone
    }
    return rawPhone
  }

  unformat(phone) {
    return phone.replace(/\D/g, "");
  }
}

export class PasswordInput extends React.Component {
  render() {
    const {value, handleChange, valid, placeholder, style, ...passThruProps} = this.props

    return (
      <span>
        <button tabIndex="-1" onClick={() => this.setState({password: !this.state.password})}>
          <span className="material-icons">
            {this.state.password ? `visibility` : `visibility_off`}
          </span>
        </button>
        <Input
            type={this.state.password ? `password` : `text`}
            value={this.state.value}
            handleChange={password => this.validate(password)}
            valid={this.state.valid}
            placeholder={this.props.placeholder || `Password`}
            style={{...this.props.style}}
            {...passThruProps}
        />
      </span>
    )
  }
  
  constructor(props) {
    super(props)

    this.state = {
      password: true,
      valid: props.valid !== undefined ? props.valid : false,
      value: props.value !== undefined ? props.value : ``,
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps !== this.props) {
      this.setState({
        valid: nextProps.valid !== undefined ? nextProps.valid : this.state.valid,
        value: nextProps.value !== undefined ? nextProps.value : this.state.value,
      })
    }
  }

  validate(password) {
    this.setState({
      valid: password.length > 0,
      value: password,
    })
    this.props.handleChange && this.props.handleChange(password, password.length > 0)
  }
}

export class Tooltip extends React.Component {
  render() {
    return (
      <span
          onMouseOver={() => this.setState({hover: true})}
          onMouseLeave={() => this.setState({hover: false})}
          style={{
            display: `inline`,
            boxSizing: `border-box`,
            borderBottom: !this.state.hover && `1px dashed #999`,
            ...this.props.outerStyle,
          }}
      >
        {
          this.props.to
          ? <A
              href={this.props.to}
            >
              {this.renderInner()}
            </A>
          : this.renderInner()
        }
        
      </span>
    )
  }

  constructor(props) {
    super(props)
    this.posToolTip = this.posToolTip.bind(this)
    this.renderInner = this.renderInner.bind(this)

    this.state = {
      hover: false,
    }
  }

  componentDidMount() {
    document.addEventListener(`mousemove`, this.posToolTip)
  }

  componentWillUnmount() {
    document.removeEventListener(`mousemove`, this.posToolTip)
  }

  renderInner() {
    // const rightHalf = this.state.mouseX > (0.5 * this.props.w)
    // const bottomHalf  = this.state.mouseY > (0.5 * this.props.h)

    return (
      <span>
        {this.props.text}
        <span
            style={{
              display: !this.state.hover && `none`,
              position: `absolute`,
              // minWidth: `40%`,
              width: `70%`,
              left: this.props.w * this.props.index + (this.state.mouseX || 0) / 10,
              // right: rightHalf ? -1 * this.props.w * this.props.index + this.state.mouseX / 30 : undefined,
              // top: bottomHalf ? undefined : this.state.mouseY+22,
              bottom: this.props.h - (this.state.mouseY || 0) + 10,
              padding: `5px`,
              border: `1px solid black`,
              borderRadius: `5px`,
              backgroundColor: `black`,
              color: `white`,
              ...this.props.innerStyle,
            }}
        >
          {this.props.tip}
        </span>
      </span>
    )
  }

  posToolTip(e) {
    this.setState({
      mouseX: e.pageX,
      mouseY: e.pageY,
    })
  }
}



// WEBPACK FOOTER //
// ./src/Parts.js